import {CustomPageHeader, Text, useText} from "@src/components";
import GeneralCompanyInformationForm from './GeneralCompanyInformationForm';

const GeneralCompanyInformation = () => {
    const companyInformation2 = useText('companyInformation2');
    return (
        <CustomPageHeader
            data-testid="general-company-information"
            title={<Text t="generalCompanyInformation"/>}
            showBreadCrumb
            showHelpButton
            routes={[companyInformation2]}
        >
            <GeneralCompanyInformationForm/>
        </CustomPageHeader>
    );
};

export default GeneralCompanyInformation;
